import HTTTP_STATUS_CODES from './httpStatusCodes.js'

export const BASE = {
  GENERIC_ERROR: {
    code: 'generic_error',
    message: 'Unknown error occurred'
  }
}

export const TRACKING = {
  GET_USER_TRAITS: {
    [HTTTP_STATUS_CODES.BAD_REQUEST]: {
      code: 'missing_anonymous_user_id',
      message: 'Request failed due to missing anonymous user id'
    },
    [HTTTP_STATUS_CODES.NOT_FOUND]: {
      code: 'unknown_anonymous_user_id',
      message: 'Request failed due to unknown anonymous user id'
    }
  }
}
